<template>
  <div class="p-1 rounded ">
    <div class="grid cursor-default items-center gap-1"
      style="grid-template-columns: minmax(0, 1fr) auto auto;"
      v-on:click="isOpen = !isOpen">
      <div class="text-white font-bold min-w-0 break-words">
        {{ title }}
      </div>
      <!-- Informational only: a group containing at least one modified
           property. Deliberately NOT the property-level reset icon — this is a
           plain dot with no action of its own (clicking the header, here
           included, only expands/collapses). Renders nothing when `modified`
           is left unset, so every other use of Accordion is unchanged. -->
      <span v-if="modified" class="flex items-center justify-center text-blue-400"
        title="Contains modified properties" aria-label="Contains modified properties">
        <font-awesome-icon icon="fa-solid fa-circle" class="text-[7px]" />
      </span>
      <span v-else></span>
      <div class="content-center">
        <div class="text-center text-white">{{ isOpen ? '▼' : '►' }}</div>
      </div>
    </div>
    <template v-if="isOpen">
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      isOpen: false,
    };
  },
  name: 'Accordion',
  props: {
    title: String,
    is_open: {
      type: Boolean,
      default: false,
    },
    // Optional: show the "contains modified properties" indicator. Callers in
    // the Property Editor derive it from propertyGroupStatus.js; everyone else
    // omits it.
    modified: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // A caller may drive the open state (e.g. per canvas mode); the user can
    // still toggle in between.
    is_open(value) {
      this.isOpen = value;
    },
  },
  mounted: function () {
    this.isOpen = this.is_open;
  },
};
</script>
